import React from 'react'
import HeroSection from '../CustomerPages/HeroSection'
const HomePage = () => {
  return (
    <div className='home-content'>
    <HeroSection/>
    </div>
  )
}

export default HomePage